import {serializable, alias, object, list, primitive} from 'serializr';

export class ContentAccessedModel { 

	@serializable(alias('total_contents', primitive()))
	totalContents?: number;

	@serializable(alias('total_videos', primitive()))
	totalVideos?: number;

	@serializable(alias('total_pdfs', primitive()))
	totalPdfs?: number;

}